export interface Network {
  id: number;
  typeId: string;
  typeName: string;
  name: string;
  controllersCount: number;
  controllersStatusMessage: string;
  controllersStatusId: number;
  controllersStatus: string;
  address: string;
}

export interface NetworkDetails {
  id: number;
  typeId: string;
  typeName?: string;
  name: string;
  address: string;
  networkStatus: string;
  networkStatusId: number;
  controllers: NetworkController[];
  events: NetworkEvent[];
  networkTypes: any;
}

export class NetworkController {
  id: number;
  name: string;
  isTestable: boolean;
  statusDate: number;
  statusDescription: string;
  statusId: number;
  typeDescription: string;
  version: string;
}

export class NetworkEvent {
  type: string;
  nameAndDescription: string;
  dateTime: number;
  operator: string;
  location: string;
}

export interface NetworkStatusSignalR {
  id: number;
  networkId?: number;
  action: string;
  description: string;
  statusDescrption: string;
  statusId: number;
  time: string;
  topic: string;
  type: NetworkSignalrType;
  typeId: number;
}

export interface PanelTestSignalR {
  boardName: string;
  bootloaderVersion: string;
  description: string;
  firmwareVersion: string;
  hardwareType: number;
  hardwareTypeId: number;
  id: number;
  isSupervisedInputs: boolean;
  time: string;
  topic: string;
}


export enum NetworkSignalrType {
  Network = 'Network',
  Panel = 'Panel'
}
